import { PageTitleActions } from '@/pages/Admin/Stores';
import React from 'react';
import styled from 'styled-components';
import PageActionItem from './PageTitle/PageActionItem';

interface Props {
   title: string;
   actions: PageTitleActions[];
   inline?: React.ReactNode;
}

const PageTitle = ({ title, actions, inline }: Props) => {
   return (
      <Wrapper>
         <TitleGroup>
            <Title>{title}</Title>
            {inline ? <InlineSlot>{inline}</InlineSlot> : null}
         </TitleGroup>
         <Actions>
            {actions.map((item, index) => (
               <div key={index}>
                  <PageActionItem
                     title={item.title}
                     type={item.type}
                     onClick={item.onClick ?? (() => {})}
                  />
               </div>
            ))}
         </Actions>
      </Wrapper>
   );
};

const Wrapper = styled.div`
   padding-top: 2rem;
   padding-bottom: 1rem;
   padding-left: 1rem;
   padding-right: 1rem;

   display: flex;
   justify-content: space-between;
   gap: 1rem;
   align-items: center;
   margin-bottom: 1rem;

   @media (max-width: 768px) {
      padding-top: 1rem;
      padding-left: 12px;
      padding-right: 12px;
      margin-bottom: 8px;
   }
`;
const TitleGroup = styled.div`
   display: flex;
   align-items: center;
   justify-content: space-between;
   gap: 12px;
   flex: 1;
   flex-wrap: wrap;
`;
const InlineSlot = styled.div`
   display: flex;
   align-items: center;
   gap: 8px;
`;
const Title = styled.p`
   font-size: 20px;
   font-weight: 700;
`;
const Actions = styled.div`
   display: flex;
   justify-content: flex-end;
   gap: 10px;
   align-items: center;
`;

export default PageTitle;
